import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { RemoveScroll } from 'react-remove-scroll';
import { DialogBackdrop } from '../../primitives/Dialog/components/Backdrop.js';
import { Container } from '../../primitives/Dialog/components/Container.js';
import { Portal } from '../../primitives/internal/Portal/index.js';
import { Fade } from '../../primitives/Transition/index.js';
const DialogComponent = forwardRef(({
  open,
  fullScreen = false,
  onClose,
  ...restProps
}, ref) => _jsxs(Portal, {
  children: [!fullScreen && _jsx(DialogBackdrop, {
    open: open,
    onClick: onClose,
    "data-testid": "dialog-backdrop"
  }), _jsx(RemoveScroll, {
    enabled: open,
    children: _jsx(Fade, {
      in: open,
      children: _jsx(Container, {
        ...restProps,
        ref: ref,
        fullScreen: fullScreen
      })
    })
  })]
}));
export const Dialog = /*#__PURE__*/_styled(DialogComponent, {
  label: 'Dialog',
  target: "evqthyd0"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkRpYWxvZy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFXRyIsImZpbGUiOiJEaWFsb2cuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBqc3ggYXMgX2pzeCwganN4cyBhcyBfanN4cyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdC9qc3gtcnVudGltZVwiO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgZm9yd2FyZFJlZiB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IFJlbW92ZVNjcm9sbCB9IGZyb20gJ3JlYWN0LXJlbW92ZS1zY3JvbGwnO1xuaW1wb3J0IHsgRGlhbG9nQmFja2Ryb3AgfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL0RpYWxvZy9jb21wb25lbnRzL0JhY2tkcm9wLmpzJztcbmltcG9ydCB7IENvbnRhaW5lciB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvRGlhbG9nL2NvbXBvbmVudHMvQ29udGFpbmVyLmpzJztcbmltcG9ydCB7IFBvcnRhbCB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvaW50ZXJuYWwvUG9ydGFsL2luZGV4LmpzJztcbmltcG9ydCB7IEZhZGUgfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL1RyYW5zaXRpb24vaW5kZXguanMnO1xuY29uc3QgRGlhbG9nQ29tcG9uZW50ID0gZm9yd2FyZFJlZigoeyBvcGVuLCBmdWxsU2NyZWVuID0gZmFsc2UsIG9uQ2xvc2UsIC4uLnJlc3RQcm9wcyB9LCByZWYpID0+IChfanN4cyhQb3J0YWwsIHsgY2hpbGRyZW46IFshZnVsbFNjcmVlbiAmJiAoX2pzeChEaWFsb2dCYWNrZHJvcCwgeyBvcGVuOiBvcGVuLCBvbkNsaWNrOiBvbkNsb3NlLCBcImRhdGEtdGVzdGlkXCI6IFwiZGlhbG9nLWJhY2tkcm9wXCIgfSkpLCBfanN4KFJlbW92ZVNjcm9sbCwgeyBlbmFibGVkOiBvcGVuLCBjaGlsZHJlbjogX2pzeChGYWRlLCB7IGluOiBvcGVuLCBjaGlsZHJlbjogX2pzeChDb250YWluZXIsIHsgLi4ucmVzdFByb3BzLCByZWY6IHJlZiwgZnVsbFNjcmVlbjogZnVsbFNjcmVlbiB9KSB9KSB9KV0gfSkpKTtcbmV4cG9ydCBjb25zdCBEaWFsb2cgPSBzdHlsZWQoRGlhbG9nQ29tcG9uZW50LCB7XG4gICAgbGFiZWw6ICdEaWFsb2cnLFxufSkgYGA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1EaWFsb2cuanMubWFwIl19 */");